export const SELECTORS = {
  leftNav: '[data-pl-leftnav-role="leftnav"]',
  menu: '[data-pl-leftnav-role="menu"]',
  collapse: '[data-pl-leftnav-role="collapse"]',
  dropdownAttr: '[data-pl-leftnav-role="dropdown"]',
  itemLinkAttr: '[data-pl-leftnav-role="menu-link"]',
  menuItemAttr: '[data-pl-leftnav-role="menu-item"]',
  nestedMenuAttr: '[data-pl-leftnav-role="nested-menu"]',
};

export const CLASSES = {
  activeClass: 'is-active',
  openClass: 'is-open',
  hiddenClass: 'is-hidden',
  closedClass: 'is-collapsed',
  expandedClass: 'is-expanded',
  scrollingClass: 'is-scrollable',
};
